module.exports = __webpack_public_path__ + "img/border-right.a58b10cb.svg";